import { Alert, AlertProps } from 'antd';
import React from 'react';
import { IconUtils } from '@/utils';

export type AppAlertProps = Omit<AlertProps, 'icon'> & {
  /** Optional icon override - if not provided, will use Font Awesome based on type */
  icon?: React.ReactNode;
};

const AppAlert: React.FC<AppAlertProps> = ({ type = 'info', icon, ...props }) => {
  const alertType = type as 'success' | 'info' | 'warning' | 'error';
  const displayIcon = icon ?? IconUtils.getIcon(alertType, true);

  return <Alert type={alertType} icon={displayIcon} {...props} />;
};

AppAlert.displayName = 'AppAlert';

export default AppAlert;
